export default __webpack_public_path__ + "static/media/matDefault.e0eb77e1.svg";